import React from 'react';
import styles from './DataTable.module.css';
import Pagination from '../Pagination';

const DataTable = ({
  columns,
  data,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  actionButton,
  onRowClick,
  highlightedRow
}) => {
  const handleRowClick = (item, index) => {
    if (onRowClick) {
      onRowClick(item, index);
    }
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableAlignContainer}>
        {actionButton && (
          <div className={styles.actionButton}>{actionButton}</div>
        )}

        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className={styles.tableHead}
                  style={{ width: column.width || 'auto' }}
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          
          {/* 테이블 바디 */}
          <tbody>
            {data.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                className={`
                  ${styles.tableRow}
                  ${item.activate === 'N' ? styles.inactiveRow : ''}
                  ${highlightedRow === rowIndex ? styles.highlightedRow : ''}
                `}
                onClick={() => handleRowClick(item, rowIndex)}
              >
                {columns.map((column, colIndex) => (
                  <td key={colIndex} className={styles.tableCell}>
                    {column.render
                      ? column.render(item[column.dataIndex], item, rowIndex)
                      : item[column.dataIndex]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 페이지네이션 영역 */}
      {/* 전체 페이지가 1보다 클 때만 페이지네이션 표시 */}
      {totalPages > 1 && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}     // 현재 페이지
            totalPages={totalPages}       // 전체 페이지 수
            onPageChange={onPageChange}   // 페이지 변경 핸들러
          />
        </div>
      )}
    </div>
  );
};

export default DataTable;